export default __webpack_public_path__ + "static/media/header-t.0da598bd.png";